<div class="container">
  <div class="wrapper">
    <div class="number">404</div>
    <div class="message">Deal not found</div>
  </div>
</div>
